import { useEffect, useState } from "react";

import t from "../../i18n/i18n";
import useApi from "../../services/api";

function Servers({ onSelect, simple }) {
  const [servers, setServers] = useState([]);

  const { ApiGetServers } = useApi();

  async function getServers() {
    const { data } = await ApiGetServers();

    // const data = [
    //   {
    //     AreaID: 1,
    //     AreaName: "Servidor 1",
    //   },
    //   {
    //     AreaID: 2,
    //     AreaName: "Servidor 2",
    //   },
    // ];

    data.sort((a, b) => {
      if (a.AreaName < b.AreaName) return -1;
      if (a.AreaName > b.AreaName) return 1;
      return 0;
    });

    setServers(data);
  }

  useEffect(() => {
    getServers();
  }, []);

  return (
    <>
      {!simple ? (
        <div className="server-select" style={{ paddingBottom: 0 }}>
          <h3>
            <span className="step-counter">1</span>
            {t("General.SelectServer")}
          </h3>
          <div className="input-radio-group">
            {servers.map((server) => {
              return (
                <div className="custom-radio">
                  <input
                    type="radio"
                    value={server.AreaID}
                    name="server"
                    id={`server${server.AreaID}`}
                    onClick={onSelect}
                  />
                  <label for={`server${server.AreaID}`}>{server.AreaName}</label>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <>
          <label>{t("General.SelectServer")}</label>
          <div className="input-radio-group">
            {servers.map((server) => {
              return (
                <div className="custom-radio">
                  <input
                    type="radio"
                    value={server.AreaID}
                    name="server"
                    id={`server${server.AreaID}`}
                    onClick={onSelect}
                  />
                  <label for={`server${server.AreaID}`}>{server.AreaName}</label>
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}

export default Servers;
